import React, { useContext, cloneElement, Children, isValidElement } from 'react';
import classNames from 'classnames';
import Context from '../common/context';
import Block from '../block';
import { wrapUnit } from '../utils';
const PageAside = (props) => {
    const { className, width, mode, children, style, ...others } = props;
    const { prefix } = useContext(Context);
    const asideCls = classNames(className, {
        [`${prefix}page-aside`]: true,
        [`${prefix}bg--${mode}`]: !!mode,
    });
    const asideInnerCls = classNames(`${prefix}page-aside-inner`);
    const newChildren = Children.map(children, (child) => {
        const { style: childStyle, ...otherChildProps } = child.props;
        if (isValidElement(child)) {
            return cloneElement(child, {
                ...otherChildProps,
                span: 1,
                style: {
                    ...childStyle,
                },
            });
        }
        else {
            return (<Block span={1} width={width}>
          {child}
        </Block>);
        }
    });
    const newStyle = {
        width: wrapUnit(width),
        ...style,
    };
    if (!children) {
        return null;
    }
    return (<aside className={asideCls} style={newStyle} {...others}>
      <div className={asideInnerCls}>{newChildren}</div>
    </aside>);
};
PageAside.displayName = 'Aside';
PageAside.typeMark = 'Aside';
PageAside.defaultProps = {
    width: 336,
    mode: 'transparent',
};
export default PageAside;
